import { render, staticRenderFns } from "./InfoHotelComponent.vue?vue&type=template&id=66c990ba&scoped=true"
import script from "./InfoHotelComponent.vue?vue&type=script&lang=js"
export * from "./InfoHotelComponent.vue?vue&type=script&lang=js"
import style0 from "./InfoHotelComponent.vue?vue&type=style&index=0&id=66c990ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c990ba",
  null
  
)

export default component.exports